/**
 * FollowupSuggestions
 * Hazır takip soruları
 */

import React from 'react';

export default function FollowupSuggestions({ suggestions, onSelect, remaining }) {
  if (!suggestions || suggestions.length === 0 || remaining <= 0) return null;
  
  return (
    <div className="oracle-followup-section">
      <div className="oracle-followup-title">
        Daha fazla sormak ister misin? ({remaining} hak)
      </div>
      
      <div className="oracle-followup-grid">
        {suggestions.slice(0, 4).map((suggestion, index) => (
          <button
            key={index}
            className="oracle-followup-btn"
            onClick={() => onSelect(suggestion.text)}
            data-testid={`followup-${index}`}
          >
            <div className="oracle-followup-icon">{suggestion.icon}</div>
            <div className="oracle-followup-text">{suggestion.text}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
